export default __webpack_public_path__ + "static/morrow-bank-e3e701e2e8096c3ca15dde0b3d70d71d.png";